import { CardStat } from './OverviewCard/CardStatLegacy';
import ClusterStat from './OverviewCard/ClusterStat';
import { GOOGLE_SORT_OPTIONS } from 'utils/metrics';
import GoogleSparkline from 'components/DataVis/GoogleSparkline';
import MetricStat from './OverviewCard/MetricStat';
import OverviewCardWrapper from './OverviewCard/OverviewCardWrapper';
import { ParentSize } from '@visx/responsive';
import { memo } from 'react';
import styled from 'styled-components';

const NoDataMessage = styled.p`
    color: ${({ theme }) => theme.neutral_5};
`;

function Card({
    id,
    label,
    type,
    name,
    timeSeries,
    cluster,
    healthStats,
    sortOption,
    onCardClick,
    healthStatKeys,
    ...props
}) {
    const secondaryMetric =
        !sortOption ||
        !sortOption.sortBy ||
        sortOption.sortBy === GOOGLE_SORT_OPTIONS.volume.sortBy
            ? GOOGLE_SORT_OPTIONS.YoY
            : GOOGLE_SORT_OPTIONS[sortOption.sortBy];
    const sortMetric = secondaryMetric.format(props[secondaryMetric.sortBy]);
    const sortLabel = secondaryMetric.label;
    return (
        <OverviewCardWrapper
            mixpanelContext="Card"
            onClick={(e) => onCardClick({ id, type })}
        >
            <Title>
                <span>{name}</span>
            </Title>
            <span
                css={`
                    margin-top: ${({ theme }) => theme.space_2}px;
                    padding: 0px ${({ theme }) => theme.space_8}px;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    gap: 0.5rem;
                `}
            >
                <MetricStat metric={sortMetric} metricLabel={sortLabel} />
                <ClusterStat cluster={cluster} />
            </span>
            <TimeseriesWrapper>
                {timeSeries && timeSeries.length ? (
                    <TimeseriesInnerWrapper>
                        <ParentSize>
                            {({ width, height }) => (
                                <GoogleSparkline
                                    data={timeSeries}
                                    width={width}
                                    height={height}
                                    skipPrediction={
                                        !healthStatKeys.includes(
                                            'predicted growth',
                                        )
                                    }
                                />
                            )}
                        </ParentSize>
                    </TimeseriesInnerWrapper>
                ) : (
                    <NoDataMessage>No data</NoDataMessage>
                )}
            </TimeseriesWrapper>
            <CardStats>
                {Object.entries(healthStats).map(([metricLabel, stat]) =>
                    !healthStatKeys.includes(metricLabel) ? null : (
                        <CardStat
                            {...stat}
                            metricLabel={metricLabel}
                            key={metricLabel}
                        />
                    ),
                )}
            </CardStats>
        </OverviewCardWrapper>
    );
}

export default memo(Card);
